import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Styles from "./index.module.css";

const Header = () => {
  return (
    <nav className={Styles.header}>
      <Container fluid>
        <Row>
          <Col xs={3} className="text-center">
            <div className={Styles.logo}>
              <Link to="/">LearnersBucket</Link>
            </div>
          </Col>
          <Col xs={6} className={Styles.menuWrapper}>
            <ul className={Styles.menu}>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/problems">Problems</Link>
              </li>
              <li>
                <Link to="/system-design">System Design</Link>
              </li>
              <li>
                <a
                  href="https://learnersbucket.com"
                  target="_blank"
                  title="blog"
                  rel="noreferrer"
                >
                  Blog
                </a>
              </li>
            </ul>
          </Col>
          <Col xs={3} className={Styles.byMeBeer}>
            <a
              href="https://www.buymeacoffee.com/learnersbucket"
              target="_blank"
              title="By me a beer"
              rel="noreferrer"
            >
              Buy me a 🍻!.
            </a>
          </Col>
        </Row>
      </Container>
    </nav>
  );
};

export default Header;
